module.exports = __webpack_public_path__ + "img/yfc-thumb2.47021fb2.png";